import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as communityActions from 'modules/community/community.actions';
import { InlineLink } from 'modules/styled';
import { Button, View } from 'modules/styled/web';

class CommunityAdminList extends Component {
  static propTypes = {
    // actions: PropTypes.object,
    community: PropTypes.object,
  };

  render() {
    const {
      community: { communities },
    } = this.props;
    return (
      <View sx={{ mt: 2 }}>
        {Object.values(communities).map((c) => (
          <View sx={{ mt: 2 }} key={c.slug}>
            <InlineLink to={`/admin/community/${c.slug}`}>{c.name}</InlineLink>
          </View>
        ))}
        <View sx={{ mt: 2 }}>
          <InlineLink to="/admin/community/new">
            <Button to="/admin/community/new" sx={{ ml: 0 }}>
              Create New
            </Button>
          </InlineLink>
        </View>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  routing: state.routing,
  community: state.community,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...communityActions,
    },
    dispatch
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CommunityAdminList)
);
